import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Icon from '@mui/material/Icon';
import { useDispatch } from "react-redux";
import { logOut, setLogedinUserInfo } from '../../login/Login_reducer';
import { Cookies } from "react-cookie";
import store from "../../../store";
import { routeHelper } from "../../../helper/helperFunctions";
import { getVatList } from "../../vatManagement/VatManagementReducer";
import { gteShoplist } from "../../shopManagement/shopmanagementReducer";
import { getproductList } from "../../productManagement/productManagementReducer";
import { getusersList } from "../../users/userManagementReducer";
import { fetchLocations } from "../../traningModule/traningmoduleReducer";






export const AdminHeader = () => {

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectMenu, setselectMenu] = React.useState(null);
  const [productNavigation, setProductNavigation] = useState(null);
  const [trainingData, setTrainingData] = useState([])
  const open = Boolean(anchorEl);
  const cookies = new Cookies();

  // ************************** FOR COOKIE SERVICE LOGIN AS USER IN USER LISTING *************************//
  const backtoUser = () => {
    cookies.set("userInfo", cookies.get('originaluserInfo'), { path: '/' });
    cookies.set("lastLoginTime", cookies.get('originaluserlastLoginTime'), { path: '/' });
    // cookies.remove("secret", { path: '/' });
    // cookies.remove("token", { path: '/' });

    cookies.remove("originaluserInfo", { path: '/' });
    cookies.remove("originaluserlastLoginTime", { path: '/' });
    cookies.remove("store_access", { path: "/" });
    // cookies.remove("token", { path: '/' });
    store.dispatch(setLogedinUserInfo(cookies.getAll()));

    // handleClose()
    navigate('/users', { replace: true })
  }


  useEffect(() => {
    console.log("Location changed", trainingData);
  }, [trainingData])

  const handleClick = (val, event) => {
    setselectMenu(val);

    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const gotosafety = () => {
    console.log("gotosafety");
    navigate("/safety-measurements", {
      replace: true,
    });
  };



  const lessonList = () => {
    console.log("lessons list");
    // dispatch(fetchTrainings());
    navigate("/list-lessons", { replace: true });
    setAnchorEl(null);

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  };
  const trainingList = () => {
    console.log("training list");
    // dispatch(fetchTrainings());
    navigate("/list-training", { replace: true });
    setAnchorEl(null);

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }

  const manageLocation = () => {
    dispatch(fetchLocations())

    navigate("/manage-locations", { replace: true });
    setAnchorEl(null);

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }
  const manageBlog = () => {

    navigate("/manage-blog", { replace: true });
    setAnchorEl(null);

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }

  
  const TraningCenter = () => {
    console.log("trainingcenter");
    // dispatch(fetchTraningCenter());
    navigate(`/trainingcenter/${trainingData}`, { replace: true });
    setAnchorEl(null);

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }


  const gotodashboard = () => {
    console.log("gotodashboard");
    navigate("/admin-dashboard", { replace: true });
    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }
  const showMenuBar = () => {
    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  };





  const openUserManagement = () => {
    navigate("/users");

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }


  const openBrandManagement = () => {
    navigate("/brand-list");

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }

  const openProductlist = () => {
    navigate("/product/list");

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }

  const gotoShop = () => {
    navigate("/list-shop")

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }
  const goToVat = () => {
    navigate("/vat-list");

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }
  const goToTestimonials = () => {
    navigate("/testimonials/list");

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  }



  //Image set for Bucket
  const bukUrl = "https://d37pbainmkhx6o.cloudfront.net/fryright_images";
  //All Image name goes here
  const Images = [
    "logo.png"
  ];



  store.subscribe(() => {
    const storeData = store.getState();
    // setProductNavigation(storeData.userDashboardKey.store_access);
    if (storeData.trainingManagmentReducer.trainingcenterdatas.training_data != undefined && storeData.trainingManagmentReducer.trainingcenterdatas.training_data.length > 0) {
      setTrainingData(storeData.trainingManagmentReducer.trainingcenterdatas.training_data[0]._id)
    }

  })

  // routeHelper({
  //   path: `/vat-list`,
  //   func: getVatList,
  //   state: store.getState().vatManagementReducer.vatList,
  //   navigate,
  //   body: reqBody,
  // })

  // routeHelper({
  //   path: `/list-shop`,
  //   func: gteShoplist,
  //   state: store.getState().shopmanagementReducer.shopList,
  //   navigate,
  //   body: reqBody,
  // })

  // routeHelper({
  //   path: `/product/list`,
  //   func: getproductList,
  //   state: store.getState().productManagmentReducer.productList,
  //   navigate,
  //   body: reqBody,
  // })

  // routeHelper({
  //   path: `/users`,
  //   func: getusersList,
  //   state: store.getState().userManagmentReducer.usersList,
  //   navigate,
  //   body: reqBody,
  // })




  return (
    <div className="pageWrapper">



      <Grid container spacing={0} className="topMenu">

        <Grid item xs={12} md={2} className="topLogo">
          <div className="loginFormLogo">
            <img src={`${bukUrl}/${Images[0]}`} />
          </div>
          <div className="navbarToggle" onClick={showMenuBar}>
            <Button id="fade-button">
              <Icon className="toggleMenu">clear_all</Icon>
            </Button>
          </div>
        </Grid>

        <Grid item xs={12} md={7} id="topMenuLists" className="topMenuLists">
          <div className="topMenuListsWrapper">
            <Button onClick={() => gotodashboard()} className={pathname.includes("admin-dashboard") ? "active" : ""}>Dashboard</Button>
            <Button onClick={() => openUserManagement()} className={pathname.includes("users") ? "active" : ""}>Users</Button>
            <Button onClick={() => openBrandManagement()} className={pathname.includes("brand-list") ? "active" : ""}>Brand</Button>
            {/* <Button>Stores</Button> */}
            <Button onClick={() => gotoShop()} className={pathname.includes("list-shop") ? "active" : ""}>Shops</Button>

            <Button
              id="fade-button"
              onClick={() => goToVat()} className={pathname.includes("vat-list") ? "active" : ""}
            >
              Vat
            </Button>

            <Button
              id="fade-button"
              aria-controls={open ? "fade-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(evt) => handleClick(5, evt)}
              className={pathname.includes("list-training") || pathname.includes("list-lessons") || pathname.includes("trainingcenter") ? "active" : ""}
            >
              Training <Icon className="expand_more">expand_more</Icon>
            </Button>




            <Button onClick={() => openProductlist()} className={pathname.includes("product/list") ? "active" : ""}>Product</Button>
            <Button
              id="fade-button"
              aria-controls={open ? "fade-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={() => gotosafety()}
              className={
                pathname.includes("safety-measurements")
                  ? "active"
                  : ""
              }
            >
              MSDS
            </Button>
            <Button
              id="fade-button"
              onClick={() => goToTestimonials()} className={pathname.includes("testimonials/list") ? "active" : ""}
            >
              Testimonials
            </Button>
            <Button
              id="fade-button"
              aria-controls={open ? "fade-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(evt) => handleClick(11, evt)}
              className={pathname.includes("manage-locations") ? "active" : ""}
            >
              Miscellaneous <Icon className="expand_more">expand_more</Icon>
            </Button>
          </div>
        </Grid>

        <Grid item xs={12} md={2} className="topRightMenu">
          <Button className="goToHome" onClick={() => navigate('/home')}>Go To Home</Button>
          <Button className="myAccount" id="fade-button"
            aria-controls={open ? "fade-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={(evt) => handleClick(7, evt)}><Icon className="account_circle">account_circle</Icon> <Icon className="expand_more">expand_more</Icon></Button>
        </Grid>
      </Grid>
      {selectMenu === 11 && (
        <Menu
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem onClick={() => manageLocation()} className={pathname.includes("manage-locations") ? "active" : ""}>Manage locations</MenuItem>
          <MenuItem onClick={() => manageBlog()} className={pathname.includes("manage-blog") ? "active" : ""}>Manage blog</MenuItem>

        </Menu>
      )}

      {selectMenu === 4 && (
        <Menu
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem onClick={handleClose}>Owner</MenuItem>
          <MenuItem onClick={handleClose}>Manager</MenuItem>
          <MenuItem onClick={handleClose}>Area-Manager</MenuItem>
        </Menu>
      )}
      {selectMenu === 5 && (
        <Menu
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem onClick={() => trainingList()} className={pathname.includes("list-training") ? "active" : ""}>Trainings</MenuItem>

          <MenuItem onClick={() => lessonList()} className={pathname.includes("list-lessons") ? "active" : ""}>Lessons </MenuItem>

          {/* <MenuItem onClick={() => TraningCenter()} className={pathname.includes("trainingcenter") ? "active" : ""}>Training Center </MenuItem> */}
        </Menu>
      )}

      {selectMenu === 7 && (
        <Menu
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >

          <MenuItem onClick={() => {
            navigate("/myaccount", { replace: true });
            setAnchorEl(false)
          }} className={pathname.includes("") ? "active" : ""}>My Account</MenuItem>


          {/* ************LOG OUT BUTTON & COOKIE SET********************* */}

          {!cookies.get('originaluserInfo') ? <MenuItem onClick={() => {
            dispatch(logOut())
            cookies.remove("userInfo", { path: '/' });
            cookies.remove("secret", { path: '/' });
            cookies.remove("token", { path: '/' });
            cookies.remove("lastLoginTime", { path: "/" });


            handleClose()
            navigate('/', { replace: true })
          }}>Log Out</MenuItem> : null}

          {/************* BACK TO ORIGINAL ACCOUNT BUTION USEING COOKIE SERVICE********** */}

          {cookies.get('originaluserInfo') ?
            <MenuItem onClick=
              {() => backtoUser()}
            // {() => {
            //   // dispatch(logOut())
            //   cookies.set("userInfo", cookies.get('originaluserInfo'), { path: '/' });
            //   cookies.set("lastLoginTime", cookies.get('originaluserlastLoginTime'),{ path: '/' });
            //   // cookies.remove("secret", { path: '/' });
            //   // cookies.remove("token", { path: '/' });

            //   cookies.remove("originaluserInfo", { path: '/' });
            //   cookies.remove("originaluserlastLoginTime", { path: '/' });
            //   // cookies.remove("token", { path: '/' });
            //  store.dispatch(setLogedinUserInfo(cookies.getAll()));

            //   handleClose()
            //   navigate('/users', { replace: true })
            // }}

            >Back to Original Account</MenuItem> : null}

        </Menu>
      )}


    </div>

  );
};
